import { useCompanyEvent } from 'components/company-profile/hooks/use-company-event';
import { EventReadinessCard } from 'components/event-readiness/EventReadinessCard';
import { useCurrentTeamCompanies } from 'hooks/use-current-team-companies';

import { DashboardShowtime, ShowtimeScanTiles } from './DashboardShowtime';

const DashboardEvent = () => {
    const { companies } = useCurrentTeamCompanies();
    const company = companies.length === 1 ? companies[0] : undefined;

    const { event: exhibitorEvent, isLoading } = useCompanyEvent({ id: company?.id ?? '' });

    if (company && isLoading) {
        return null;
    }

    const exhibitor = exhibitorEvent ? company : undefined;

    if (!exhibitor) {
        return <DashboardShowtime />;
    }

    return (
        <EventReadinessCard company={exhibitor}>
            <ShowtimeScanTiles asBand />
        </EventReadinessCard>
    );
};

export { DashboardEvent };
